<!--
//================================================================================
// ID:BC053
// ProjectName: 都営住宅募集オンライン申請
// SystemName: 都営住宅募集オンラインシステム
// JavaScriptName:BC053
//
// <<Modification History>>
// Version  | Date       | Updated By			| Content
// ---------+------------+-----------------------+--------------------------------
// 01.00.00 | 2022/10/24 | 富士通Japan株式会社	 | 新規作成
// 01.01.00 | 2023/09/27 | 富士通Japan株式会社   | 令和5年度改修対応（3次リリース）
//================================================================================
-->
<template>
	<main class="contents__main">
		<error-message/>
		<div>
			<main>
				<div class="contents__input-main">
					<div class="contents__title">
						<label class="contents__title--label"></label>
					</div>
					<br>
					<section>
						<h2 class="contents__h2 bosyujyutaku__title">募集住宅情報</h2>
						<table class="contents__table--stripe detail">
							<tbody>
								<tr>
									<th class="contents__input--title">募集の種類</th>
									<td class="width-bosyu-kind">
										<label>随時募集（先着順）</label>
									</td>
								</tr>
								<tr class="contents__input--tr">
									<th class="contents__input--title">住宅の種別</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label>{{ disp.jyutakuKindName }}</label>
										</div>
									</td>
								</tr>
								<tr class="contents__input--tr">
									<th class="contents__input--title">公募年月</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label>{{ form.ymBosyu.substring(0,4) }}年{{ form.ymBosyu.substring(4) }}月</label>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">申込地区番号</th>
									<td class="width-bosyu-kind">
										<label>{{ form.noMouchikuLbl }}</label>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">入居人数</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label>{{ disp.cdNyukyoName }}</label>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">区市町</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label>{{ disp.cdKusicyosonName }}</label>
										</div>
									</td>
								</tr>
								<tr class="contents__input--tr">
									<th class="contents__input--title padding__bottom-zero">団地区分</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label>{{ form.cdDanchi }}</label>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">住宅名</th>
									<td class="padding__top-zero">
										<div class="label-line-height">
											<label>{{ form.txJyutakuName }}</label>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">代表的な所在地</th>
									
									<td class="padding__top-zero">
										<div class="label-line-height">
											<label>{{ form.txKusicyo }}</label>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">外部マップサービスのリンク先</th>
									<td class="padding__top-zero">
										<div class="label-line-height contents__kaigyo--css">
											<a :href="disp.txMapLink" target="_blank" rel="noopener noreferrer" tabindex="-1">{{ this.form.txMapLink }}</a>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">主な交通機関</th>
									<td class="padding__top-zero">
										<div class="label-line-height">
											<label v-if="form.txTrans != null">{{ form.txTrans }}</label>
											<label class="hidden-word" v-else>主な交通機関</label>
										</div>
									</td>
								</tr>
								<tr class="contents__input--tr">
									<th class="contents__input--title padding__bottom-zero">徒歩区分</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.kbToho != null">{{ disp.kbTohoName }}</label>
											<label class="hidden-word" v-else>徒歩区分</label>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">駅・バス停からの徒歩時間</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.nuToho != null">{{ form.nuToho }}分</label>
											<label class="hidden-word" v-else>駅・バス停からの徒歩時間</label>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title">バスの利用有無</th>
									<td class="busUmu-title">
										<div class="marginTop15px">
											<label v-if="form.fgbusRiyou != null">{{ disp.fgbusRiyouName }}</label>
											<label class="hidden-word" v-else>バスの利用有無</label>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">募集戸数</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label>{{ form.nuBosyuKosu }}戸</label>
										</div>
									</td>
								</tr>
								<tr class="contents__input--tr">
									<th class="contents__input--title padding__bottom-zero">間取り１</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.cdMadori1 != null">{{ disp.cdMadori1Name }}</label>
											<label class="hidden-word" v-else>間取り１</label>
										</div>
									</td>
								</tr>
								<tr class="contents__input--tr">
									<th class="contents__input--title padding__bottom-zero">間取り２</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.cdMadori2 != null">{{ disp.cdMadori2Name }}</label>
											<label class="hidden-word" v-else>間取り２</label>
										</div>
									</td>
								</tr>
								<tr class="contents__input--tr">
									<th class="contents__input--title padding__bottom-zero">間取り３</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.cdMadori3 != null">{{ disp.cdMadori3Name }}</label>
											<label class="hidden-word" v-else>間取り３</label>
										</div>
									</td>
								</tr>
								<tr class="contents__input--tr">
									<th class="contents__input--title padding__bottom-zero">間取り表示用</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.txMadoriLbl != null">{{ form.txMadori }}</label>
											<label class="hidden-word" v-else>間取り表示用</label>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">専用面積</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="!co_isEmpty(form.nuSenyoLow) && !co_isEmpty(form.nuSenyoUpr)">{{ form.nuSenyoLow }}m&sup2; ～ {{ form.nuSenyoUpr }}m&sup2;</label>
											<label v-else-if="!co_isEmpty(form.nuSenyoLow) && co_isEmpty(form.nuSenyoUpr)">{{ form.nuSenyoLow }}m&sup2;</label>
											<label class="hidden-word" v-else>専用面積</label>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">建設年度</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.yyKensetuLow != null && form.yyKensetuUpr != null">{{ form.yyKensetuLow }}年 ～ {{ form.yyKensetuUpr }}年</label>
											<label v-else-if="form.yyKensetuLow != null && form.yyKensetuUpr == null">{{ form.yyKensetuLow }}年</label>
											<label class="hidden-word" v-else>建設年度</label>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title">エレベーターの有無</th>
									<td class="elevatorUmu-title">
										<div class="marginTop15px">
											<label v-if="form.fgElevator != null">{{ disp.fgElevatorName }}</label>
											<label class="hidden-word" v-else>エレベーターの有無</label>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">使用料</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.moSiyoryoLow != null && form.moSiyoryoUpr != null">{{ co_commaSeparated(form.moSiyoryoLow) }}円 ～ {{ co_commaSeparated(form.moSiyoryoUpr) }}円</label>
											<label v-else-if="form.moSiyoryoLow != null && form.moSiyoryoUpr == null">{{ co_commaSeparated(form.moSiyoryoLow) }}円</label>
											<label class="hidden-word" v-else>使用料</label>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">仕様等</th>
									<td class="padding__top-zero">
										<div class="label-line-height">
											<label v-if="form.txSiyou != ''">{{ form.txSiyou }}</label>
											<label class="hidden-word" v-else>仕様等</label>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title">バリアフリーの有無</th>
									<td class="busUmu-title">
										<div class="marginTop15px">
											<label v-if="form.fgBarrierfree != null">{{ disp.fgBarrierfreeName }}</label>
											<label class="hidden-word" v-else>バリアフリーの有無</label>
										</div>
									</td>
								</tr>
								<tr v-if="form.jyutakuKind == '23'">
									<th class="contents__input--title padding__bottom-zero">事故内容</th>
									<td class="padding__top-zero">
										<div class="label-line-height">
											<label v-if="form.txJikonaiyo != null">{{ form.txJikonaiyo }}</label>
											<label v-else class="hidden-word">事故内容</label>
										</div>
									</td>
								</tr>
								<tr v-if="form.jyutakuKind == '23'">
									<th class="contents__input--title padding__bottom-zero">対象階</th>
									<td class="padding__top-zero">
										<div class="marginTop15px">
											<label v-if="form.txJikotaisyo != null">{{ form.txJikotaisyo }}</label>
											<label v-else class="hidden-word">対象階</label>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
						<br>
						<h2 class="contents__h2 zuiji__title">募集期間</h2>
						<table class="contents__table--stripe detail">
							<tbody>
								<tr>
									<th class="contents__input--title padding__bottom-zero">公開開始日時</th>
									<td class="padding__top-zero padding__bottom-date">
										<div class="marginTop15px">
											<label>{{ form.dmKokaiSttYear }}年{{ form.dmKokaiSttMonth }}月{{ form.dmKokaiSttDay }}日 {{ form.dmKokaiSttHour }}時{{ form.dmKokaiSttMin }}分</label>
										</div>
									</td>
								</tr>
								<tr>
									<th class="contents__input--title padding__bottom-zero">公開終了日時</th>
									<td class="padding__top-zero padding__bottom-date">
										<div class="marginTop15px">
											<label>{{ form.dmKokaiEndYear }}年{{ form.dmKokaiEndMonth }}月{{ form.dmKokaiEndday }}日 {{ form.dmKokaiEndHour }}時{{ form.dmKokaiEndMin }}分</label>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
						<br>
						<h2 class="contents__h2 zuiji__title">変更内容の反映日時</h2>
						<table class="contents__table--stripe detail">
							<tbody>
								<tr>
									<th class="contents__input--title padding__bottom-zero">変更反映日時</th>
									<td class="padding__top-zero padding__bottom-date">
										<div class="marginTop15px">
											<label v-if="form.dmTekiyoStt != '------------'">{{ form.dmTekiyoSttYear }}年{{ form.dmTekiyoSttMonth }}月{{ form.dmTekiyoSttDay }}日 {{ form.dmTekiyoSttHour }}時{{ form.dmTekiyoSttMin }}分</label>
											<label v-else class="hidden-word">変更反映日時</label>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
						<br>
						<div class="contents__div--center margin__bottom-page">
							<input
								type="button"
								value="この内容で変更する"
								tabindex="1"
								class="contents__btn--confirm btn-kakunin"
								@click="clickChangeBtn">
							<input
								type="button"
								value="内容を修正する"
								tabindex="2"
								class="contents__btn--cancel btn-modoru"
								@click="clickBackBtn">
						</div>
					</section>
				</div>
			</main>
		</div>
	</main>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue';

import { co_post, co_put, co_setError } from '@/common/ajaxUtility.js';
import { co_completedDialog, co_confirmDialog } from '@/common/dialogUtility.js';
import { co_commaSeparated } from '@/common/stringUtility.js';
import { co_getMessage } from '@/common/messageUtility.js';
import { co_toTop, co_toTrans, co_clearParam } from '@/common/screenUtility.js';
import { co_isEmpty } from '@/common/checkUtility';

import { DIALOG_BUTTON_LIST_KEY, HTTP_STATUS } from '@/const/const.js';
import { STORE_ERROR_CLEAR, STORE_ERROR_IS_ERRFLG, STORE_VIEW_PROGRESS, STORE_ERROR_SETMSG,
			STORE_DATA_DELETE_AT, STORE_VIEW_GET_PARAMS } from '@/const/store.js';
import { PATH_BC053_CODENAME, PATH_BC053_JUTAKUINFO, PATH_BC053_EDITJUTAKU } from '@/const/route.js';

export default {
	name: "BC053",
	components: {
		'error-message': ErrorMessage,
	},
	data: function () {
		return {
			form: {
				dmTekiyoSttYearBefore: '',		// 変更前変更反映日時（年）
				dmTekiyoSttMonthBefore: '',		// 変更前変更反映日時（月）
				dmTekiyoSttDayBefore: '',		// 変更前変更反映日時（日）
				dmTekiyoSttHourBefore: '',		// 変更前変更反映日時（時）
				dmTekiyoSttMinBefore: '',		// 変更前変更反映日時（分）
			},
			disp: {
				jyutakuKindName: '',			// 住宅の種別名称
				cdNyukyoName: '',				// 入居人数名称
				cdKusicyosonName: '',			// 区市町村名称
				kbTohoName: '',					// 徒歩区分名称
				fgbusRiyouName: '',				// バス利用の有無名称
				cdMadori1Name: '',				// 間取り１名称
				cdMadori2Name: '',				// 間取り２名称
				cdMadori3Name: '',				// 間取り３名称
				fgElevatorName: '',				// エレベーターの有無名称
				fgBarrierfreeName: '',			// バリアフリーの有無名称
				txMapLink: '',					// 外部マップサービスのリンク先
			},
			zyutakuInfo: [],					// 随時募集住宅変更情報
			co_commaSeparated: co_commaSeparated,
			co_isEmpty: co_isEmpty
		}
	},
	created: async function() {

		// エラークリア
		this.$store.commit(STORE_ERROR_CLEAR);

		// ローディング表示開始
		this.$store.commit(STORE_VIEW_PROGRESS, true);

		// 遷移元画面からのパラメータを取得
		let params = this.$store.getters[STORE_VIEW_GET_PARAMS]('BC053');
		this.zyutakuInfo = params.zyutakuInfo;

		// パラメータ設定
		this.form = this.zyutakuInfo;

		// 外部マップサービスのリンク先
		this.disp.txMapLink = this.form.txMapLink;

		// 画面間パラメータを削除
		co_clearParam('BC053');

		// コード名所取得
		let codeName = await co_post(PATH_BC053_CODENAME, this.form)
		
		// 初期値設定
		// 住宅の種別
		this.disp.jyutakuKindName = codeName.jyutakuKindName;
		// 公募年月（年）
		this.form.ymBosyuYear = this.zyutakuInfo.ymBosyuYear;
		// 公募年月（月）
		this.form.ymBosyuMonth = this.zyutakuInfo.ymBosyuMonth;
		// 入居人数
		this.disp.cdNyukyoName = codeName.cdNyukyoName;
		// 区市町村
		this.disp.cdKusicyosonName = codeName.cdKusicyosonName;
		// 徒歩区分
		this.disp.kbTohoName = codeName.kbTohoName;
		// バス利用の有無
		this.disp.fgbusRiyouName = codeName.fgbusRiyouName;
		// 間取り１
		this.disp.cdMadori1Name = codeName.cdMadori1Name;
		// 間取り２
		this.disp.cdMadori2Name = codeName.cdMadori2Name;
		// 間取り３
		this.disp.cdMadori3Name = codeName.cdMadori3Name;
		// エレベーターの有無
		this.disp.fgElevatorName = codeName.fgElevatorName;
		// バリアフリーの有無
		this.disp.fgBarrierfreeName = codeName.fgBarrierfreeName;
		// 公開開始日時
		this.form.dmKokaiSttYear = this.zyutakuInfo.dmKokaiStt.substring(0, 4);
		this.form.dmKokaiSttMonth = this.zyutakuInfo.dmKokaiStt.substring(4, 6);
		this.form.dmKokaiSttDay = this.zyutakuInfo.dmKokaiStt.substring(6, 8);
		this.form.dmKokaiSttHour = this.zyutakuInfo.dmKokaiStt.substring(8, 10);
		this.form.dmKokaiSttMin = this.zyutakuInfo.dmKokaiStt.substring(10, 12);
		// 公開終了日時
		this.form.dmKokaiEndYear = this.zyutakuInfo.dmKokaiEnd.substring(0, 4);
		this.form.dmKokaiEndMonth = this.zyutakuInfo.dmKokaiEnd.substring(4, 6);
		this.form.dmKokaiEndday = this.zyutakuInfo.dmKokaiEnd.substring(6, 8);
		this.form.dmKokaiEndHour = this.zyutakuInfo.dmKokaiEnd.substring(8, 10);
		this.form.dmKokaiEndMin = this.zyutakuInfo.dmKokaiEnd.substring(10, 12);
		// 変更前変更反映日時
		this.form.dmTekiyoSttYearBefore = this.zyutakuInfo.dmTekiyoSttYear;
		this.form.dmTekiyoSttMonthBefore = this.zyutakuInfo.dmTekiyoSttMonth;
		this.form.dmTekiyoSttDayBefore = this.zyutakuInfo.dmTekiyoSttDay;
		this.form.dmTekiyoSttHourBefore = this.zyutakuInfo.dmTekiyoSttHour;
		this.form.dmTekiyoSttMinBefore = this.zyutakuInfo.dmTekiyoSttMin;
		// 変更後変更反映日時
		this.form.dmTekiyoSttYear = this.zyutakuInfo.dmTekiyoStt.substring(0, 4);
		this.form.dmTekiyoSttMonth = this.zyutakuInfo.dmTekiyoStt.substring(4, 6);
		this.form.dmTekiyoSttDay = this.zyutakuInfo.dmTekiyoStt.substring(6, 8);
		this.form.dmTekiyoSttHour = this.zyutakuInfo.dmTekiyoStt.substring(8, 10);
		this.form.dmTekiyoSttMin = this.zyutakuInfo.dmTekiyoStt.substring(10, 12);

		// ローディング表示終了
		this.$store.commit(STORE_VIEW_PROGRESS, false);
	},
	mounted: async function () {
		await this.$nextTick();

		// ページトップへ遷移
		co_toTop();
	},
	methods: {

		// この内容で変更するボタン押下
		clickChangeBtn: async function () {

			// エラークリア
			this.$store.commit(STORE_ERROR_CLEAR);

			// 確認ダイアログ表示
			co_confirmDialog(co_getMessage("W0017"), this.doChange);
			return;
		},
		// 確認ダイアログ「はい」ボタン押下時処理
		doChange: async function (flg) {
			// ダイアログ「はい」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {

				// ローディング表示開始
				this.$store.commit(STORE_VIEW_PROGRESS, true);

				// 変更前の随時募集住宅情報取得
				let beforeJutakuInfo = await co_post(PATH_BC053_JUTAKUINFO, this.form);

				// 変更済みの場合
				if (beforeJutakuInfo.henkozumiFlg == true) {
					// エラーメッセージ：E0108を表示
					this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0108'));

					// ローディング表示終了
					this.$store.commit(STORE_VIEW_PROGRESS, false);

					// ページトップへ遷移
					co_toTop();

					return;
				}

				// 公開開始日時超過チェック
				if (beforeJutakuInfo.koakaikaisiTyokaFlg == true) {
					// エラーメッセージ：E0108を表示
					this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0109', '公開開始日時'));

					// ページトップへ遷移
					co_toTop();
				}

				// 公開終了日時超過チェック
				if (beforeJutakuInfo.koakaisyuryoTyokaFlg == true) {
					// エラーメッセージ：E0108を表示
					this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0109', '公開終了日時'));

					// ページトップへ遷移
					co_toTop();
				}

				// 適用開始日時超過チェック
				if (beforeJutakuInfo.tekiyokaisiTyokaFlg == true) {
					// エラーメッセージ：E0108を表示
					this.$store.commit(STORE_ERROR_SETMSG, co_getMessage('E0109', '変更反映日時'));

					// ページトップへ遷移
					co_toTop();
				}

				// ローディング表示終了
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				// 入力チェックエラーが存在しない場合
				if (!this.$store.getters[STORE_ERROR_IS_ERRFLG]) {
				
					// ローディング表示開始
					this.$store.commit(STORE_VIEW_PROGRESS, true);

					// 随時募集住宅情報登録・更新・削除処理呼び出し
					await co_put(PATH_BC053_EDITJUTAKU, this.form, this.callbackEntry);
				}
			}
			// ダイアログ「いいえ」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.CANCEL) {
				// ダイアログを閉じる
				return;
			}
		},
		// 随時募集住宅情報登録・更新・削除完了処理(コールバック関数)
		callbackEntry: function (res) {
			// 随時募集住宅情報登録・更新・削除処理：正常終了
			if (res.status == HTTP_STATUS.CREATED) {
				// プログレスバー非表示
				this.$store.commit(STORE_VIEW_PROGRESS, false);

				// 完了ダイアログ表示
				co_completedDialog(co_getMessage("I0023"), this.doCompletedChange);

			} else {
				// 業務エラー表示
				co_setError(res.data, this.$refs);

				// プログレスバー非表示
				this.$store.commit(STORE_VIEW_PROGRESS, false);
			}
		},
		doCompletedChange: async function (flg) {
			// ダイアログ「はい」ボタン押下時処理
			if (flg == DIALOG_BUTTON_LIST_KEY.OK) {
				// 変更画面の状態管理情報を削除
				this.$store.commit(STORE_DATA_DELETE_AT, 'BC052');

				// 住宅一覧（随時募集・管理者用）へ遷移する
				co_toTrans('BC051');
			}
		},
		// 内容を修正するボタン押下
		clickBackBtn: async function () {

			// 変更前の変更反映日時
			this.form.dmTekiyoStt = this.form.dmTekiyoSttYearBefore + this.form.dmTekiyoSttMonthBefore + this.form.dmTekiyoSttDayBefore
									+ this.form.dmTekiyoSttHourBefore + this.form.dmTekiyoSttMinBefore;
			// 変更前の公募年月
			this.form.ymBosyu = this.form.ymBosyuYear + this.form.ymBosyuMonth;
			// 住宅情報変更入力（随時募集・管理者用）へ遷移する。
			let params = {
							bosyuKind: this.form.bosyuKind,
							jyutakuKind: this.form.jyutakuKindBefore,
							ymBosyu: this.form.ymBosyu,
							noMouchiku: this.form.noMouchiku,
							tekiyokaishi: this.form.dmTekiyoStt,
							zyokyo: this.form.zyokyo
						};
			co_toTrans('BC052', params);
		},
	}
};
</script>

<style scoped>

.width-mouchiku {
	width: 75px;
}

.width-bosyuKosu {
	width: 40px;
}

.marginRight-bosyuKosu {
	margin-right: 5px;
}

.marginLeft-bosyuKosu {
	margin: 0 10px 0 5px;
}

.width-koubo,
.width-madori {
	width: auto;
}

.width-textarea {
	width: -webkit-fill-available;
}

.width-toho-text,
.width-menseki-text,
.width-kensetu-text {
	width: 50px;
	margin-right: 10px;
	text-align: right;
}

.width-siyoryo-text {
	width: 75px;
	margin-right: 10px;
	text-align: right;
}

.width-jikonaiyo-text {
	width: 90%;
}

.padding__bottom-date {
	padding-bottom: 20px !important;
}

.marginTop15px {
	margin-top: 15px;
}

.marginTop22px {
	margin-top: 22px;
}

.marginTop6px {
	margin-top: 6px;
}

.hidden-word {
	color:transparent;
	user-select: none;
}

.contents__main {
	margin-left: 1% !important;
	margin-right: 1% !important;
}

.contents__input-main {
	margin-top: -2%;
}

.contents__table--stripe td {
	line-height: 0px;
}

.bosyujyutaku__title {
	margin-top: 1% !important;
	margin-bottom: 1% !important;
}

.width-bosyu-kind {
	padding-top: 25px !important;
}

.zuiji__title {
	margin-top: 2% !important;
	margin-bottom: 1% !important;
}

.btn-kakunin {
	margin-bottom: 2%;
}

.btn-modoru {
	margin-left: 1%;
}

.contents__hissu {
	right: 1%;
}

.width-kushicyo {
	margin-top: 20px;
	margin-bottom: 5px;
}

.width-jyutaku-text,
.width-kushicyo-text {
	width: 83%;
}

.label-line-height {
	line-height: 1.4em;
	margin-top: 4px;
}
</style>